import { PortalModule } from '@angular/cdk/portal';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AtxStep } from './components/step/step.component';
import { AtxStepperIndicators } from './components/stepper-indicators/stepper-indicators.component';
import { AtxStepper } from './components/stepper/stepper.component';
import { AtxStepLabel } from './directives/step-label/step-label.directive';
import { AtxStepperNext } from './directives/stepper-next/stepper-next.directive';
import { AtxStepperPrevious } from './directives/stepper-previous/stepper-previous.directive';

@NgModule({
  declarations: [
    AtxStepper,
    AtxStep,
    AtxStepLabel,
    AtxStepperNext,
    AtxStepperPrevious,
    AtxStepperIndicators,
  ],
  imports: [CommonModule, CdkStepperModule, PortalModule],
  exports: [
    AtxStepper,
    AtxStep,
    AtxStepLabel,
    AtxStepperNext,
    AtxStepperPrevious,
    AtxStepperIndicators,
  ],
})
export class StepperModule {}
